import { createAction, createActionGroup, props } from "@ngrx/store";

export const userLoginAction = createActionGroup({
    source: 'User Login',
    events: {
        'Load User Login': props<{ status: 'request' | 'success' | 'failure', body?: any, data?: any, error?: any }>(),                     // triggers effect
    }
})

export const updateLogOutData = createAction(
    '[User Logout] Update Logout Data',
    props<{ data: any }>()
);